// src/pages/ChapterTwo.js
import React, { useState, useCallback } from "react";
import ChapterTemplate from "../components/ChapterTemplate";
import { happyBirthdayMelody } from "../data/melodies";
import { getChapterMeta, markChapterComplete } from "../utils/progression";

export default function ChapterTwo() {
  const CHAPTER = 2;
  const meta = getChapterMeta(CHAPTER);

  const [matchedNotes, setMatchedNotes] = useState([]);

  // Let ChapterTemplate show its own Star Quest modal,
  // but still mark chapter complete in your progression store.
  const handleComplete = useCallback(() => {
    try { markChapterComplete(CHAPTER); } catch {}
  }, []);

  // ✅ 4-line wrap (matching uses these lines via ChapterTemplate)
  const happyBirthdayLines = [
    ["C","C","D","C","F","E"],
    ["C","C","D","C","G","F"],
    ["C","C","C5","A","F","E","D"],
    ["A#","A#","A","F","G","F"],
  ];

  const storySlides = [
    {
      image: "/images/ChapterTwo/piano-note-asharp.png",
      text: "🎯 New Note Unlocked: A# (A-sharp)\nSpot it on your keyboard before we begin!",
    },
    { image: "/images/ChapterTwo/questDescrip.png",},
    { image: "/images/ChapterTwo/zebra-birthday2.png",},
    { image: "/images/ChapterTwo/zebra-birthday.png",},
    { image: "/images/ChapterTwo/pan-Zebrabirthday.png",},
  ];

  return (
    <ChapterTemplate
      chapterNumber={CHAPTER}
      chapterTitle={meta?.title || "Zeb’s Birthday"}
      storySlides={storySlides}
      targetMelody={happyBirthdayMelody}
      melodyLines={happyBirthdayLines}      // used for matching & display
      matchedNotes={matchedNotes}
      onNoteMatched={setMatchedNotes}
      onRealComplete={handleComplete}       // Template opens the star modal
      onVirtualComplete={handleComplete}    // Template opens the star modal
      unlockNextChapterPath="/chapter-3"    // Next button in modal goes here
      skillPoints={meta?.skillPoints ?? 7}
      layoutMode="cinema"
      sceneImageSrc="/images/ChapterTwo/zebra-birthday2.png"
      songTitle="Happy Birthday"
    />
  );
}
